import React from "react";

function Analysis() {
  return <div className="container">Analysis Bleow</div>;
}

export default Analysis;
